import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import Header from './header'
import Footer from './footer'
import Announcement from '../announcement'
import LoginModal from 'src/components/modals/login-modal'
import { graphql, useStaticQuery, Link } from 'gatsby'
import { useAuthService } from 'theme/services/auth/auth-service'
// import CookieConsent from 'react-cookie-consent'
import { getEventLink, getConferenceLocation } from 'theme/utils/generic-helpers'
import { isEqual } from 'lodash-es'
import { AppServiceProvider } from 'theme/services/app-service'

const BasicLayout = ({ children }) => {
  const authService = useAuthService()
  const { conferences, announcements } = useStaticQuery(query)

  const filteredAnnouncements = announcements?.nodes?.filter((ann) => !ann.data.Conference) || []
  const mainConferences = conferences.nodes.filter((conference) => {
    return conference.data.Type === 'Conference' || conference.data.Type === 'Training'
  })

  const [liveConference, setLiveConference] = useState(null)
  const [showLiveConference, setShowLiveConference] = useState(true)

  useEffect(() => {
    const getLiveConference = () => {
      return conferences.nodes.filter((conference) => {
        return (
          new Date(conference.data.Live_Start_Time).getTime() - 1000 * 60 * 30 < Date.now() &&
          new Date(conference.data.Live_End_Time).getTime() > Date.now()
        )
      })[0]
    }
    // setLiveConference(conferences.nodes[0])
    setLiveConference(getLiveConference())
    const timer = setInterval(() => {
      const tempLiveConference = getLiveConference()
      if (!isEqual(tempLiveConference, liveConference)) setLiveConference(tempLiveConference)
    }, 1000 * 60)
    return () => clearInterval(timer)
  }, [])

  return (
    // FIXME: we don't load pageProps atm as uxdx is now the default config for all components
    <AppServiceProvider appInfo={{ app: { appName: 'uxdx' } }}>
      <div className="grid grid-rows-1 min-h-screen font-sans text-gray-900">
        {/* <div className='grid grid-rows-1 min-h-screen font-sans text-gray-900 h-screen'> */}
        <Header conferences={{ nodes: mainConferences }} />
        {liveConference && showLiveConference && (
          <div className="bg-red-600 relative mt-24 -mb-24">
            <div className="max-w-7xl mx-auto py-3 px-3 sm:px-6 lg:px-8 mt-1">
              <div className="flex items-center justify-between flex-wrap">
                <div className="w-0 flex-1 flex items-center">
                  <span className="flex p-2 rounded-lg bg-red-800">
                    <svg
                      className="h-6 w-6 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z"
                      />
                    </svg>
                  </span>
                  {new Date(liveConference.data.Online_Start_Time).getTime() < Date.now() && (
                    <p className="ml-3 font-medium text-white truncate">
                      {liveConference.data.Conference_Name} is live now! Don&apos;t miss out...
                    </p>
                  )}
                  {new Date(liveConference.data.Online_Start_Time).getTime() > Date.now() && (
                    <p className="ml-3 font-medium text-white truncate">
                      {liveConference.data.Conference_Name} is starting shortly! Don&apos;t miss out...
                    </p>
                  )}
                </div>
                <div className="order-3 mt-2 flex-shrink-0 w-full sm:order-2 sm:mt-0 sm:w-auto">
                  <Link
                    to={getEventLink(
                      liveConference.data.Conference_Id,
                      getConferenceLocation(liveConference),
                      'live',
                    )}
                    className="flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-red-600 bg-white hover:bg-red-50"
                  >
                    View Now
                  </Link>
                </div>
                <div className="order-2 flex-shrink-0 sm:order-3 sm:ml-3">
                  <button
                    type="button"
                    onClick={() => setShowLiveConference(false)}
                    className="-mr-1 flex p-2 rounded-md hover:bg-red-500 focus:outline-none focus:ring-2 focus:ring-white sm:-mr-2"
                  >
                    <span className="sr-only">Dismiss</span>
                    <svg
                      className="h-6 w-6 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        <main className="pt-24">
          {filteredAnnouncements.length > 0 && <Announcement announcements={filteredAnnouncements} />}
          {children}
          {/* <div className='max-w-7xl mx-auto py-6 sm:px-6 lg:px-8'>{children}</div> */}
        </main>

        <Footer conferences={{ nodes: mainConferences }} />

        {/* <CookieConsent
          location="bottom"
          buttonText="Accept"
          disableStyles="true"
          containerClasses="flex flex-wrap left-10 p-8 max-w-prose bg-slate-200 shadow-3xl rounded-lg border-2 border-gray-300 fixed z-10 mb-4"
          style={{ bottom: '10px !important' }}
          contentClasses=""
          buttonClasses="bg-blue-500 py-2 px-4 mt-4 text-white rounded-md"
          overlayStyle={{ backgroundColor: 'rgba(0, 0, 0, 0.7)' }}
          cookieName="gatsby-gdpr-google-tagmanager"
        >
          <span className="font-medium">We use cookies in the delivery of our services.</span> To learn about
          the cookies we use and information about your preferences and opt-out choices, please{' '}
          <Link to="/cookie-policy" className="text-blue-800">
            click here
          </Link>
          . By using our platform you agree to our use of cookies.
        </CookieConsent> */}
      </div>
      {authService.loginModal?.isVisible && (
        <LoginModal
          openModal={authService.loginModal.isVisible}
          handleClose={() => authService.handleModalClose()}
        />
      )}
    </AppServiceProvider>
  )
}

const query = graphql`
  query headerData {
    conferences: allAirtableConference(
      filter: {
        data: {
          Conference_Status: { eq: "Published" }
          Organisation: { eq: "UXDX" }
          Future_Conference: { eq: "FUTURE" }
        }
      }
      sort: { data: { Conference_Start_Date: ASC } }
    ) {
      nodes {
        data {
          Conference_Id
          Conference_Name
          Conference_Start_Date
          Conference_End_Date
          Menu_Link_Overview
          On_Demand_Start_Time
          Online_Start_Time
          Online_End_Time
          Type
          Location
        }
      }
    }
  }
`
// announcements: allAirtableAnnouncements(filter: { data: { Future_Announcement: { eq: "FUTURE" } } }) {
//   nodes {
//     data {
//       Start_Date: Announcement_Start_Date
//       End_Date: Announcement_End_Date
//       Long_Text
//       Button_Text
//       Button_Link
//       Conference {
//         id
//       }
//     }
//   }
// }

BasicLayout.propTypes = {
  children: PropTypes.node.isRequired,
  announcement: PropTypes.object,
}

export default BasicLayout
